import Layout from "../../elements/layout";

export default function FindMatePage() {
  return (
    <Layout>
      <div className="sk-py-2 sk-pl-5 sk-pr-7 sk-w-full">
        <div>
          <h2 className="sk-text-xl sk-font-semibold sk-mb-0">Cari Pasangan</h2>
          <p className="sk-text-sm sk-text-neutral-400 sk-font-semibold">
            Cari pasangan yang cocok untukmu
          </p>
        </div>
      </div>
    </Layout>
  );
}
